import { ArrowForward } from "@mui/icons-material";
import { Box, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import TextButton from "./TextButton";

type WidgedHeaderProps = {
  title: string;
  count?: number;
  /**
   * Route the top-right "View All" link navigates to. Omit it on widgets with no destination view
   * yet — the link is then hidden rather than left dead.
   */
  viewAllHref?: string;
};

const WidgedHeader = ({ title, count, viewAllHref }: WidgedHeaderProps) => {
  const navigate = useNavigate();
  return (
    <Box className="flex items-center justify-between mb-2 mt-6">
      <Box sx={{ display: "inline-flex", alignItems: "center", gap: 1 }}>
        <Typography
          variant="h3"
          style={{ fontFamily: "var(--font-crimson)" }}
          sx={{
            fontWeight: 400,
            fontSize: "20px",
            lineHeight: 1,
            letterSpacing: "-0.6px",
            color: "var(--color-rodeo-black)",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {title}
        </Typography>
        {count != null && (
          <Box
            component="span"
            sx={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              minWidth: 22,
              minHeight: 22,
              px: 1,
              borderRadius: "999px",
              backgroundColor: (theme) => theme.palette.primary.main,
              fontSize: "12px",
              fontWeight: 700,
              color: (theme) => theme.palette.primary.contrastText,
            }}
            aria-label={`${count} items`}
          >
            {count}
          </Box>
        )}
      </Box>
      {viewAllHref && (
        <TextButton
          sx={{ mr: -0.5 }}
          endIcon={<ArrowForward sx={{ fontSize: 14 }} />}
          onClick={() => navigate(viewAllHref)}
        >
          View All
        </TextButton>
      )}
    </Box>
  );
};

export default WidgedHeader;
